import { createDynamicQueryResource } from '@subtile/project-shared';
import type { Accessor } from 'solid-js';
import document, { type WalletTransactionsVars } from '../queries/walletTransactionsQuery';
import type { WalletTransactions } from '../types';

export default (variables: Accessor<WalletTransactionsVars | null>) =>
  createDynamicQueryResource<WalletTransactions, WalletTransactionsVars>(document, variables);
